import { CheckAsyncStatus, ExportToCSV, GetCompanies, GetOperableFiscalPeriods, TransferStructuresAsync, TransferStructuresResult, TransferValuesAsync, TransferValuesResult, ValidateAccessKey } from "../../../Constants/ConstantsValue";
import { BaseAction, ContentType, RootAction } from "../RootAction";

export const getOperableFiscalPeriods = (params, callBack) => dispatch => {
  let action = new BaseAction({
    type: RootAction.MainPage.GetOperableFiscalPeriods,
    method: "POST",
    params: params,
    endPoint: GetOperableFiscalPeriods
  });

  if (callBack) {
    dispatch(action.ToPlanObject())
      .then((res) => {
        callBack(res);
      });
  }
  else {
    dispatch(action.ToPlanObject());
  }
}

export const validateAccessKey = (params, callBack) => dispatch => {
  let action = new BaseAction({
    type: RootAction.Access.ValidateAccessKey,
    method: "POST",
    params: params,
    endPoint: ValidateAccessKey
  });

  dispatch(action.ToPlanObject())
    .then((res) => {
      callBack(res);
    });
};

export const getCompanies = () => {
  let action = new BaseAction({
    type: RootAction.MainPage.GetCompanies,
    method: "GET",
    params: null,
    endPoint: GetCompanies
  });

  return action.ToPlanObject();
}

export const transferValuesAsync = (params, callBack) => dispatch => {
  let action = new BaseAction({
    type: RootAction.MainPage.TransferValuesAsync,
    header: null,
    method: "POST",
    params: params,
    endPoint: TransferValuesAsync,
    isLoading: false,
  });
  dispatch(action.ToPlanObject())
    .then((res) => {
      callBack(res);
    });
}

export const transferStructuresAsync = (params, callBack) => dispatch => {
  let action = new BaseAction({
    type: RootAction.MainPage.TransferStructuresAsync,
    header: null,
    method: "POST",
    params: params,
    endPoint: TransferStructuresAsync,
    isLoading: false,
  });
  dispatch(action.ToPlanObject())
    .then((res) => {
      callBack(res);
    });
}

export const checkAsyncStatus = (params, callBack) => dispatch => {
  let action = new BaseAction({
    type: RootAction.MainPage.CheckAsyncStatus,
    header: null,
    method: "POST",
    params: params,
    endPoint: CheckAsyncStatus,
    isLoading: false,
    //autoRedirect: false
  });

  dispatch(action.ToPlanObject())
    .then((res) => {
      callBack(res);
    });
}

export const transferValuesResult = (params, callBack) => dispatch => {
  let action = new BaseAction({
    type: RootAction.MainPage.TransferValuesResult,
    header: null,
    method: "POST",
    params: params,
    endPoint: TransferValuesResult,
    isLoading: false,
    //autoRedirect: false
  });

  dispatch(action.ToPlanObject())
    .then((res) => {
      callBack(res);
    });
}

export const transferStructuresResult = (params, callBack) => dispatch => {
  let action = new BaseAction({
    type: RootAction.MainPage.TransferStructuresResult,
    header: null,
    method: "POST",
    params: params,
    endPoint: TransferStructuresResult,
    isLoading: false,
    //autoRedirect: false
  });

  dispatch(action.ToPlanObject())
    .then((res) => {
      callBack(res);
    });
}

export const exportCSV = (params, callBack) => dispatch => {
  let action = new BaseAction({
    type: RootAction.MainPage.ExportCSV,
    contentType: ContentType.Blob,
    header: null,
    method: "POST",
    params: params,
    endPoint: ExportToCSV,
    //autoRedirect: false
  });

  dispatch(action.ToPlanObject())
    .then((res) => {
      callBack(res);
    });
}

export const setSelectedFiscalPeriodInfo = (fiscalPeriodStateModel) => {
  let action = new BaseAction({
    type: RootAction.MainPage.SetSelectedFiscalPeriodInfo,
    data: fiscalPeriodStateModel
  });

  return action.ToPlanObject();
}